module.exports = __webpack_public_path__ + "static/media/blackweeklogo.41bb8152.png";